import { createAction } from 'redux-actions'
import { v4 } from 'uuid'
import pick from 'lodash/pick'

import { DEFAULT_TYPE, OPTIONS, TYPES } from './constants'

const getValidType = (type = DEFAULT_TYPE) => {
  if (TYPES.includes(type)) {
    return type
  }

  console.warn(
    `Invalid type for addNotification \`${type}\`. Valid types: ${TYPES.join(', ')}`
  )

  return DEFAULT_TYPE
}

/**
 * Create a notification action
 *
 * @param {string} message - the notification message
 * @param {object} options
 * @param {string} [options.id] - The static ID for the alert, will be generated if not passed (typical scenario)
 * @param {string} [options.source] - The source/title of the notification
 * @param {string} [options.type='info'] - Amount of time in ms that should pass before notification is removed
 * @param {boolean} [options.icon] - Whether to show the icon
 */
export const addNotification = createAction(
  'notifications/ADD',

  (message, options = {}) => {
    const { id, type, ...restOptions } = options

    return {
      id: id || v4(),
      message,
      type: getValidType(type),
      ...pick(restOptions, ...OPTIONS),
    }
  },
)

/**
 * Create a remove notification action
 *
 * @param {string} id - The generated uuid for the alert
 */
export const removeNotification = createAction('notifications/REMOVE', id => ({ id }))

/**
 * Create action to clear all notifications
 */
export const clearNotifications = createAction('notifications/CLEAR')
